import React, { useState, useEffect } from 'react';
import store from './store';
import { Modal, Form, Table, Button, message, Popover } from 'antd';
import { observer } from 'mobx-react';
import styles from './index.module.less'
import { http } from 'libs';


export default observer(function IFormWms() {
  const [data, setData] = useState([]);
  const [selectedId, setSelectedId] = useState([]);

  useEffect(() => {
    if (store.stockOutItemList.length > 0) {
      setData(store.stockOutItemList.filter(x => x.isWms === 1))
    }
  }, [])

  function handleError(info) {
    Modal.error({
      width: 700,
      title: '详细信息',
      content: info.synced_status,
    });
  }

  const handleDownLoad = (info,type)=>{
    console.log(info);
    if (type==='url') {
      window.open(info.expressList&&info.expressList[0]?.url)
    }else{
      window.open(info.deliverFileUrl)
    }
  }

  function handlerConfirm(ids) {
    Modal.confirm({
      title: '操作确认',
      content: `确定要确认收货吗？`,
      onOk: () => http.patch(
        '/api/stock/out/item/', { id: ids })
        .then(() => {
          message.success('操作成功');
          store.fetchRecords()
        })
    })
  }



  const columns = [ {
    title: '物料名称',
    align:'center',
    dataIndex: 'name',
    render: info => store.record.goodsName,
  }, {
    title: '物料编码',
    align:'center',
    dataIndex: 'materialCode',
    render: info => store.record.materialCode,
  }, {
    title: '实际出库数',
    align:'center',
    width:80,
    dataIndex: 'outNumber'
  }, {
    title: '状态',
    align:'center',
    width:70,
    dataIndex: 'statusName'
  },{
    title: '送货单号',
    align:'center',
    width:120,
    dataIndex: 'deliverSn'
  }, {
    title: '送货单电子版',
    width:120,
    align:'center',
    render: (val,info) => <Button disabled={info.deliverFileUrl?false:true} type="link" style={{ fontSize: '0.0625rem' }} onClick={()=>{handleDownLoad(info,'deliverFileUrl')}} >下载</Button>
  }, {
    title: '送货单签字版',
    width:120,
    align:'center',
    render: (val,info) => <Button disabled={info.expressList&&info.expressList[0]?.url?false:true} type="link" style={{ fontSize: '0.0625rem' }} onClick={()=>{handleDownLoad(info,'url')}} >下载</Button>
  },   {
    title: '物流单号',
    align:'center',
    width: 120,
    dataIndex: 'no',
    render: (val,info) => info.expressList&&info.expressList[0]?.no,
  }, {
    title: '物流公司',
    align:'center',
    width: 120,
    dataIndex: 'company',
    render: (val,info) => info.expressList&&info.expressList[0]?.company,
  },  {
    title: '物流信息',
    // render: info => <Button type='link' style={{ fontSize: '0.0625rem' }} onClick={() => store.showLogistics(info.expressList)}>查询</Button>
    align:'center',
    render: (val,info) => info.expressList&&info.expressList[0]?.no ?
        <span>
          <Popover
            placement="right"
            title={<span style={{ fontSize: '0.0625rem' }}>物流详情</span>}
            trigger="click"
            content={ info.expressList[0]?.detail&&JSON.parse(info.expressList[0]?.detail).map((item, index) => (
              <p style={{ fontSize: '0.0625rem' }}>{item.time} {item.context}</p>
            ))}>
            <Button type="link" style={{ fontSize: '0.0625rem' }} >查看详情</Button>
          </Popover>
        </span>
        : <Button type="link" disabled style={{ fontSize: '0.0625rem' }} >自配送</Button>

     },
  ]

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      console.log(selectedRowKeys);
      setSelectedId(selectedRowKeys)
    },
    getCheckboxProps: (record) => ({
      disabled: record.is_confirm_receive === true || record.cangku_name !== '供应商直发仓',
      // Column configuration not to be checked
      name: record.name,
    }),
  };


  return (
    <Modal
      title={'物流详情'}
      visible={true}
      width={'1300px'}
      maskClosable={false}
      footer={[<Button type='primary' onClick={()=>{store.formWmsVisible = false}}>确定</Button>]}
      onCancel={()=>{store.formWmsVisible = false}}
    >
      <Form>
        {/* <Form.Item>
          <Button type='primary' disabled={!selectedId.length} onClick={()=>handlerConfirm(selectedId.join())}>确认收货</Button>
        </Form.Item> */}
        <Form.Item>
          <Table
            rowKey='id'
            className={styles.Table}
            size={'small'}
            // rowSelection={rowSelection}
            pagination={{
              showSizeChanger: true,
              showLessItems: true,
              hideOnSinglePage: true,
              pageSizeOptions: ['10', '20', '50', '100']
            }}
            columns={columns}
            dataSource={data}
          >
          </Table>
        </Form.Item>
      </Form>
    </Modal>
  )



})
